import { gql } from "@apollo/client";

export const GET_USER_FEED = gql`
  query getUserFeed($input: UserFeedInput!) {
    getUserFeed(input: $input) {
      type
      id
      content
      author {
        id
        name
        profile_bio
        display_name
        profile_picture {
          url
        }
      }
      likes
      total_reactions
      impressions
      mentioned {
        id
        name
        profile_bio
        profile_picture {
          url
        }
      }
      associated_with {
        id
        name
        profile_picture {
          url
        }
      }
      tags {
        tag_id
        tag_name
      }
      total_reactions
      total_comments
      reaction_by_me {
        reaction_type
      }
      comments
      seconds_ago
      media {
        id
        type
        processing_state
        url
        thumbnail_url
      }
      links
      location {
        type
        coordinates
      }
      location_name

      ai_analysis {
        suggestions
        responsible_entities
      }
      createdAt
      automated_post
    }
  }
`;

// Messaging
export const USER_MESSAGING = gql`
  query UserMessaging($input: UserMessagingInput!) {
    userMessaging(input: $input) {
      id
      messaging_owner {
        id
        name
        display_name
        first_name
        last_name
        profile_bio
        profile_picture {
          url
          type
        }
      }
      chats {
        id
        chat_owner {
          id
          name
          profile_picture {
            url
          }
        }
        chat_with {
          id
          name
          profile_picture {
            url
          }
        }
        chat_name
        chat_description
        chat_profile_picture {
          id
          type
          url
          thumbnail_url
        }
        last_message {
          id
          message_type
          content
          attachments {
            id
            type
            url
            thumbnail_url
          }
          sent_on
          delivered_on
          seen_on
          message_sender {
            id
            name
            profile_picture {
              url
            }
          }
          message_reciever {
            id
            name
            profile_picture {
              url
            }
          }
          shared_post {
            id
            type
            content
            automated_post
            author {
              id
              name
              profile_picture {
                url
              }
            }
            media {
              id
              type
              url
              thumbnail_url
            }
            tags {
              tag_id
              tag_name
            }
            mentioned {
              id
              name
              profile_bio
              profile_picture {
                url
              }
            }

            createdAt
          }
        }
        unread_count
        message_subscriptions
        chat_type
        chat_members {
          id
          name
          profile_picture {
            url
          }
        }
        chat_admins {
          id
          name
          profile_picture {
            url
          }
        }
        current_user_chat_settings {
          id
          chat_id
          chat_user {
            id
            name
            profile_picture {
              url
            }
          }
          chat_blocked
          chat_muted
        }
        user_chat_settings {
          id
          chat_id
          chat_user {
            id
            name
            profile_picture {
              url
            }
          }
          chat_blocked
          chat_muted
        }
        chat_blocked
        chat_muted
        createdAt
        updatedAt
      }
      total_unread_chats
    }
  }
`;

export const BLOCKED_CHATS = gql`
  query BlockedChats($input: UserMessagingInput!) {
    blockedChats(input: $input) {
      id
      chat_owner {
        id
        name
        profile_picture {
          url
        }
      }
      chat_with {
        id
        name
        profile_picture {
          url
        }
      }
      chat_name
      chat_description
      chat_profile_picture {
        id
        type
        url
        thumbnail_url
      }
      last_message {
        id
        message_sender {
          id
          name
          profile_picture {
            url
          }
        }
        message_reciever {
          id
          name
          profile_picture {
            url
          }
        }
        message_chat {
          id
        }
        message_type
        content
        read
        sent_on
        delivered_on
        seen_on
      }
      unread_count
      message_subscriptions
      chat_type
      chat_members {
        id
        name
        profile_picture {
          url
        }
      }
      chat_admins {
        id
        name
        profile_picture {
          url
        }
      }
      current_user_chat_settings {
        id
        chat_id
        chat_user {
          id
          name
          profile_picture {
            url
          }
        }
        chat_blocked
        chat_muted
      }
      user_chat_settings {
        id
        chat_id
        chat_user {
          id
          name
          profile_picture {
            url
          }
        }
        chat_blocked
        chat_muted
      }
      chat_blocked
      chat_muted
      createdAt
      updatedAt
    }
  }
`;

export const USER_CHAT = gql`
  query UserChat($input: UserChatInput!) {
    userChat(input: $input) {
      id
      chat_owner {
        id
        name
        profile_picture {
          url
        }
      }
      chat_with {
        id
        name
        profile_picture {
          url
        }
      }
      chat_name
      chat_description
      chat_profile_picture {
        id
        type
        url
        thumbnail_url
      }
      last_message {
        id
        message_type
        content
        attachments {
          id
          type
          url
          thumbnail_url
        }
        sent_on
        delivered_on
        seen_on
        message_sender {
          id
          name
          profile_picture {
            url
          }
        }
        message_reciever {
          id
          name
          profile_picture {
            url
          }
        }
        shared_post {
          id
          type
          content
          automated_post
          author {
            id
            name
            profile_picture {
              url
            }
          }
          media {
            id
            type
            url
            thumbnail_url
          }
          mentioned {
            id
            name
            profile_picture {
              url
            }
          }
          tags {
            tag_id
            tag_name
          }
          createdAt
        }
      }
      messages {
        id
        message_type
        content
        attachments {
          id
          type
          url
          thumbnail_url
        }
        sent_on
        delivered_on
        seen_on
        message_sender {
          id
          name
          profile_picture {
            url
          }
        }
        message_reciever {
          id
          name
          profile_picture {
            url
          }
        }
        shared_post {
          id
          type
          content
          automated_post
          author {
            id
            name
            profile_picture {
              url
            }
          }
          media {
            id
            type
            url
            thumbnail_url
          }
          mentioned {
            id
            name
            profile_picture {
              url
            }
          }
          tags {
            tag_id
            tag_name
          }
          createdAt
        }
      }
      unread_count
      message_subscriptions
      chat_type
      chat_members {
        id
        name
        profile_picture {
          url
        }
      }
      chat_admins {
        id
        name
        profile_picture {
          url
        }
      }
      current_user_chat_settings {
        id
        chat_id
        chat_user {
          id
          name
          profile_picture {
            url
          }
        }
        chat_blocked
        chat_muted
      }
      user_chat_settings {
        id
        chat_id
        chat_user {
          id
          name
          profile_picture {
            url
          }
        }
        chat_blocked
        chat_muted
      }
      chat_blocked
      chat_muted
      createdAt
      updatedAt
    }
  }
`;

export const SEARCH_TAGS = gql`
  query searchTags($tag_name_prefix: String!, $first: Int!) {
    searchTags(tag_name_prefix: $tag_name_prefix, first: $first) {
      tag_id
      tag_name
    }
  }
`;
export const SEARCH_MENTIONS = gql`
  query searchMentioned($name_prefix: String!, $first: Int!) {
    searchMentioned(name_prefix: $name_prefix, first: $first) {
      id
      name
      profile_picture {
        url
      }
    }
  }
`;
export const CHECK_USERNAME = gql`
  query CheckUsername($name_prefix: String!, $first: Int!) {
    searchMentioned(
      name_prefix: $name_prefix
      first: $first
      search_type: "exact"
    ) {
      id
      name
    }
  }
`;

export const GET_POST_BY_ID = gql`
  query getPostById($post_id: ID!) {
    getPost(post_id: $post_id) {
      type
      id
      content
      author {
        id
        display_name
        name
        profile_picture {
          url
          thumbnail_url
        }
      }
      likes
      total_reactions
      impressions
      total_comments
      reaction_by_me {
        reaction_type
      }
      mentioned {
        id
        name
        profile_bio
        profile_picture {
          url
        }
      }
      associated_with {
        id
        name
        profile_picture {
          url
        }
      }
      tags {
        tag_id
        tag_name
      }
      total_reactions

      seconds_ago
      media {
        id
        type
        processing_state
        url
        thumbnail_url
      }
      links
      location {
        type
        coordinates
      }
      location_name
      ai_analysis {
        suggestions
        responsible_entities
      }
      createdAt
      automated_post
    }
  }
`;
export const CHECK_FOLLOW = gql`
  query checkFollowerOrPatron($userId: ID!) {
    checkFollowerOrPatron(user_id: $userId) {
      follower
      patron
      follow_pending
      patron_pending
    }
  }
`;

export const GET_USER_POSTS = gql`
  query GetUserPosts($input: UserFeedInput!) {
    getUserPosts(input: $input) {
      type
      id
      content
      author {
        id
        name
        display_name
        profile_picture {
          url
        }
      }
      likes
      mentioned {
        id
        name
        profile_bio
        profile_picture {
          url
        }
      }
      associated_with {
        id
        name
        profile_picture {
          url
        }
      }
      tags {
        tag_id
        tag_name
      }
      total_reactions
      impressions
      comments
      total_comments
      reaction_by_me {
        reaction_type
      }
      seconds_ago
      media {
        id
        type
        processing_state
        url
        thumbnail_url
      }
      links
      location {
        type
        coordinates
      }
      location_name
      ai_analysis {
        suggestions
        responsible_entities
      }
      createdAt
      automated_post
    }
  }
`;
export const GET_INFLUENCE_GRAPH = gql`
  query GetInfluenceGraph(
    $user_id: ID!
    $bounding_circle_radius: Int
    $viewport_center: [Float]
    $level: String
  ) {
    getInfluenceGraph(
      user_id: $user_id
      bounding_circle_radius: $bounding_circle_radius
      viewport_center: $viewport_center
      level: $level
    ) {
      latitude
      longitude
    }
  }
`;

export const MARKETPLACE_SELLERS = gql`
  query MarketPlaceSellers($input: MarketPlaceSellersInput!) {
    marketPlaceSellers(input: $input) {
      id
      name
      display_name
      profile_picture {
        url
        thumbnail_url
      }
      total_listings
    }
  }
`;
export const GET_COMMENTS = gql`
  query GetComments($input: PostCommentsInput!) {
    getComments(input: $input) {
      comment_id
      comment_by {
        id
        name
        display_name
        profile_picture {
          url
        }
      }
      mentioned {
        id
        name
        profile_bio
        profile_picture {
          url
        }
      }

      tags {
        tag_id
        tag_name
      }
      reaction_by_me {
        reaction_type
      }
      total_reactions
      content
      createdAt
      updatedAt
    }
  }
`;

export const GET_REACTIONS = gql`
  query getReactions($input: GetReactionsInput!) {
    getReactions(input: $input) {
      reaction_id
      reaction_by {
        id
        name
        display_name
        profile_picture {
          url
        }
      }
      reaction_type
    }
  }
`;

export const GET_NOTIFICATIONS = gql`
  query GetNotifications($input: GetNotificationsInput!) {
    getNotifications(input: $input) {
      id
      content
      additional_content
      createdAt
      updatedAt
      type
      read
      who_followed {
        id
        name
        display_name
        first_name
        last_name
        profile_picture {
          url
          type
        }
      }
      who_became_patron {
        id
        name
        display_name
        first_name
        last_name
        profile_picture {
          url
          type
        }
      }
      who_mentioned {
        id
        name
        display_name
        first_name
        last_name
        profile_picture {
          url
          type
        }
      }
      who_requested {
        id
        name
        display_name
        first_name
        last_name
        profile_picture {
          url
          type
        }
      }
      who_reacted {
        id
        name
        display_name
        first_name
        last_name
        profile_picture {
          url
          type
        }
      }
      reaction {
        reaction_type
      }
      who_replied {
        id
        name
        display_name
        first_name
        last_name
        profile_picture {
          url
          type
        }
      }
      who_posted {
        reaction_type
      }
      post_id {
        id
      }
      comment_id {
        id
      }
    }
  }
`;

export const CHECK_NEW_NOTIFICATIONS = gql`
  query CheckNewNotification($input: CheckNewNotificationInput!) {
    checkNewNotification(input: $input)
  }
`;

export const GET_POPULAR_USERS = gql`
  query getPopularUsers($input: popularUserInput!) {
    popularUsers(input: $input) {
      id
      name
      display_name
      first_name
      last_name
      profile_bio
      profile_picture {
        url
      }
      follower_count
      patron_count
      total_association_score
    }
  }
`;
export const GET_TAGGED = gql`
  query GetTagged($input: TagsInput!) {
    getTagged(input: $input) {
      ... on UserFeedPost {
        type
        id
        content
        author {
          id
          display_name
          name
          profile_picture {
            url
          }
        }
        likes
        total_reactions
        impressions
        mentioned {
          id
          name
          profile_bio
          profile_picture {
            url
          }
        }
        associated_with {
          id
          name
          profile_picture {
            url
          }
        }
        tags {
          tag_id
          tag_name
        }
        total_reactions
        total_comments
        reaction_by_me {
          reaction_type
        }
        comments
        seconds_ago
        media {
          id
          type
          url
        }
        links
        location {
          type
          coordinates
        }
        location_name
        ai_analysis {
          suggestions
          responsible_entities
        }
        createdAt
        automated_post
      }
      ... on CommentInfo {
        comment_id
        comment_by {
          id
          name
          profile_picture {
            url
          }
        }
        mentioned {
          id
          name
          profile_bio
          profile_picture {
            url
          }
        }
        tags {
          tag_id
          tag_name
        }
        reaction_by_me {
          reaction_type
        }
        total_reactions
        content
        createdAt
      }
    }
  }
`;

export const SUGGESTED_USERS = gql`
  query SuggestedUsers($input: SuggestedUsersInput!) {
    suggestedUsers(input: $input) {
      id
      name
      display_name
      profile_bio
      profile_picture {
        url
      }
    }
  }
`;

export const SEARCH_QUERY = gql`
  query Search($input: SearchInput!) {
    search(input: $input) {
      content {
        __typename
        ... on UserFeedPost {
          id
          type
          content
          createdAt
          author {
            id
            display_name
            name
            profile_picture {
              url
              thumbnail_url
            }
          }
          likes
          mentioned {
            id
            name
            profile_bio
            profile_picture {
              url
            }
          }
          associated_with {
            id
            name
            profile_picture {
              url
            }
          }
          tags {
            tag_id
            tag_name
          }
          total_reactions
          impressions
          total_comments
          reaction_by_me {
            reaction_type
          }
          comments
          seconds_ago
          media {
            url
            type
          }
          links
          location {
            type
            coordinates
          }
          location_name
          ai_analysis {
            suggestions
            responsible_entities
          }
          automated_post
        }
        ... on CommentInfo {
          comment_id
          content
          createdAt
          updatedAt
          comment_by {
            id
            name
            profile_picture {
              url
            }
          }
          mentioned {
            id
            name
            profile_bio
            profile_picture {
              url
            }
          }

          tags {
            tag_id
            tag_name
          }
          total_reactions
          reaction_by_me {
            reaction_type
          }
        }
      }
      accounts {
        id
        name
        display_name
        profile_picture {
          url
          thumbnail_url
        }
        is_being_followed
        is_being_patroned
        patron_pending
        follow_pending
      }
      tags {
        tag_id
        tag_name
        total_tagged
      }
      near_content {
        type
        id
        content
        author {
          id
          display_name
          name
          profile_picture {
            url
          }
        }
        likes
        total_reactions
        impressions
        mentioned {
          id
          name
          profile_bio
          profile_picture {
            url
          }
        }
        associated_with {
          id
          name
          profile_picture {
            url
          }
        }
        tags {
          tag_id
          tag_name
        }
        total_reactions
        total_comments
        reaction_by_me {
          reaction_type
        }
        comments
        seconds_ago
        media {
          id
          type
          url
        }
        links
        location {
          type
          coordinates
        }
        location_name
        ai_analysis {
          suggestions
          responsible_entities
        }
        createdAt
      }
    }
  }
`;

export const GET_NOTIFICATIONS_COUNT = gql`
  query GetUnreadNotifications {
    getUnreadNotifications
  }
`;
export const GET_FILTERED_NOTIFICATIONS_COUNT = gql`
  query GetFilteredUnreadNotificationsCount {
    getFilteredUnreadNotifications {
      all
      mentions
      replies
      reactions
    }
  }
`;

export const EXPLORE_POSTS = gql`
  query ExplorePosts($input: ExplorePageInput!) {
    explorePosts(input: $input) {
      type
      id
      content
      author {
        id
        name
        display_name
        first_name
        last_name
        profile_bio
        profile_picture {
          id
          type
          url
          thumbnail_url
        }
      }
      likes
      total_reactions
      impressions
      mentioned {
        id
        name
        display_name
        first_name
        last_name
        profile_bio
        profile_picture {
          id
          type
          url
          thumbnail_url
        }
      }
      associated_with {
        id
        name
        profile_picture {
          url
          thumbnail_url
        }
      }
      tags {
        tag_id
        tag_name
      }
      total_reactions
      total_comments
      reaction_by_me {
        reaction_type
      }
      comments
      seconds_ago
      media {
        id
        type
        processing_state
        url
        thumbnail_url
      }
      links
      location {
        type
        coordinates
      }
      location_name
      ai_analysis {
        suggestions
        responsible_entities
      }
      createdAt
      automated_post
    }
  }
`;

export const TRENDING_TAGS = gql`
  query TrendingTags($first: Int!, $trending_duration: TrendingDuration) {
    trendingTags(first: $first, trending_duration: $trending_duration) {
      tag_id
      tag_name
      total_tagged
    }
  }
`;

export const GET_USER_PROBLEMS_PRAISE = gql`
  query GetProblemPraise($input: ProblemPraiseInput!) {
    getProblemPraise(input: $input) {
      type
      id
      content
      author {
        id
        display_name
        name
        profile_picture {
          url
        }
      }
      likes
      mentioned {
        id
        name
        profile_picture {
          url
        }
      }
      associated_with {
        id
        name
        profile_picture {
          url
        }
      }
      tags {
        tag_id
        tag_name
      }
      total_reactions
      impressions
      comments
      total_comments
      reaction_by_me {
        reaction_type
      }
      seconds_ago
      media {
        id
        type
        processing_state
        url
      }
      links
      location {
        type
        coordinates
      }
      location_name
      ai_analysis {
        suggestions
        responsible_entities
      }
      createdAt
      automated_post
    }
  }
`;
export const GET_ASSOCIATION_LIST = gql`
  query GetAssociationList($input: AssociationListInput!) {
    getAssociationList(input: $input) {
      id
      name
      display_name
      first_name
      last_name
      profile_picture {
        url
        type
      }
    }
  }
`;

export const VERIFY_PASSWORD = gql`
  query VerifyPassword($email_address: String!, $password: String!) {
    verifyPassword(email_address: $email_address, password: $password)
  }
`;
export const GET_PRODUCT_LISTING = gql`
  query GetProductListing($input: ProductListingInput!) {
    productListing(input: $input) {
      products {
        type
        id
        content
        author {
          id
          display_name
          name
          profile_picture {
            url
          }
        }

        total_reactions
        impressions

        total_comments
        reaction_by_me {
          reaction_type
        }
        seconds_ago
        media {
          id
          type
          processing_state
          url
          thumbnail_url
        }
        links
        location {
          type
          coordinates
        }
        location_name
        createdAt
        is_wishlisted
        total_wishlists
        product {
          id
          product_title
          SKU
          status
          category
          shippable
          subcategories {
            tag_id
            tag_name
          }
          price
          price_unit
          product_description
        }
      }
      total_results
    }
  }
`;

export const SELLER_PROFILE = gql`
  query SellerProfile($input: getUserInput) {
    queryUser(input: $input) {
      id
      name
      display_name
      profile_picture {
        url
        thumbnail_url
      }
      store {
        name
        description
        details
        links
        contact_number
        country_code
        location {
          type
          coordinates
        }
        location_name
        date_of_establishment
        media {
          id
          type
          url
          thumbnail_url
        }
        store_qr {
          id
          type
          url
          thumbnail_url
        }
        store_categories
        total_listings
      }
      total_listings
    }
  }
`;

export const GET_ELECTIONS = gql`
  query GetElections($input: GetElectionInput) {
    election(input: $input) {
      id
      election_identifier
      election_title
      election_location
      election_start
      election_end
      stages
      current_stage
      ward_number
      region_circle {
        center
        radius
      }
      elections {
        id
        election_identifier
        election_title
        election_location
        election_start
        election_end
        ward_number
        region_circle {
          center
          radius
        }
      }
    }
  }
`;
export const GET_ELECTION_CAMPAIGN_DETAILS = gql`
  query GetElectionCampaignDetails($input: GetElectionInput) {
    election(input: $input) {
      id
      election_identifier
      election_title
      election_location
      election_start
      election_end
      stages
      current_stage
      region_circle {
        center
        radius
      }
      total_votes
      ward_number
      elections {
        id
        election_identifier
        election_title
        election_location
        election_start
        election_end
        ward_number
        region_circle {
          center
          radius
        }
        total_votes
        candidates {
          id
          ward_id
          votes
          vote_share
          other_details
          candidate_status
          affiliation {
            id
            name
            display_name
            party_election_symbol {
              id
              url
              thumbnail_url
            }
            profile_picture {
              url
              thumbnail_url
            }
          }
          candidate {
            id
            name
            display_name

            profile_picture {
              url
              thumbnail_url
            }
          }
        }
      }
      candidates {
        id
        ward_id
        votes
        vote_share
        other_details
        affiliation {
          id
          name
          display_name
          party_election_symbol {
            id
            url
            thumbnail_url
          }
          profile_picture {
            url
            thumbnail_url
          }
        }
        candidate {
          id
          name
          display_name
          profile_picture {
            url
            thumbnail_url
          }
        }
      }
    }
  }
`;

export const CHECK_IS_ADMIN = gql`
  query CheckIsAdmin {
    isAdmin
  }
`;

export const GET_PROBLEM_PRAISE_HEATMAP = gql`
  query GetProblemPraiseHeatmap($input: InfluenceGraphFilters!) {
    problemPraiseHeatmap(input: $input) {
      posts {
        post_id
        coordinates
      }
      clusters
    }
  }
`;

export const FINAL_RESULTS = gql`
  query FinalResults($input: GetFinalResultsInput!) {
    electionFinalResults(input: $input) {
      candidates {
        candidate_name
        affiliation
        ward
        division
        votes
      }
    }
  }
`;
